import React from "react";
import SendPasswordResetToken from "../components/SendPasswordResetToken";

const SendPasswordResetTokenPage = () => {
  return (
    <>

      {/* SignInLayer */}
      <SendPasswordResetToken />

    </>
  );
};

export default SendPasswordResetTokenPage;   
